<template>
    <div class="CategoryContainer categories-filter">
        <span class="title">{{ $t("category.label") }}</span>
        <select v-model="localCategory">
            <option value="">{{ $t("category.default") }}</option>
            <option v-for="category in categories" v-bind:value="category.category_id">{{ category.name }}</option>
        </select>
    </div>
</template>

<script>
  export default {
    data () {
      return {
        category: this.category_id || ''
      };
    },

    props: [
      'categories',
      'category_id'
    ],

    computed: {
      localCategory: {
        get () {
          return this.category;
        },
        set (val) {
          this.$emit('input', val);
          this.category = val;
        }
      }
    }
  };
</script>

<style scoped>
  .CategoryContainer {
    padding: 3px 10px;
  }

  .CategoryContainer .title {
    font-weight: 300;
    font-family: 'Roboto Condensed';
  }

  select {
    font-weight: 300;
    font-family: 'Roboto';
    /* line-height: 1.5em; */
    height: 2.5em;
    border: 1px solid #737373;
  }

  @media screen and (max-width : 575px) {
    .CategoryContainer select {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// filter-by-category.vue?60c18422